export const LOCATION = {
  ANY: { ID: 0 },
  BLAGOVESHCHENSK: { ID: 4683 },
  EKB: { ID: 4743 },
  KALUGA: { ID: 4780 },
  KAZAN: { ID: 4777 },
  KHABAROVSK: { ID: 5039 },
  MOSCOW_AND_AREA: { ID: -1 },
  NIZHNIYNOVGOROD: { ID: 4596 },
  NOVOROSSIYSK: { ID: 4896 },
  OBNINSK: { ID: 4908 },
  PERM: { ID: 4927 },
  ROSTOV: { ID: 4959 },
  SPB_AND_AREA: { ID: -2 },
  TYUMEN: { ID: 5024 },
  ULAN_UDE: { ID: 5026 },
  VLADIVOSTOK: { ID: 4701 },
  YAROSLAVL: { ID: 5075 },
  YUZHNOSAHALINSK: { ID: 5069 },
} as const;
